import React from "react";
import { useSelector } from "react-redux";
import externalRedirect from "../../img/icons/datasheets.svg";
import localization from "../../data/config";
import ToolTip from "../ToolTip";

const Datasheets = (props) => {
  const viewDataSheetLabel = useSelector(state => state.labels.button.viewDataSheet)

  return (
    <div className="parts__refdocuments">
      <div className="parts__reference__document">
        <span className="parts__tooltip-wrapper">
          <ToolTip label={viewDataSheetLabel} />
          <a
            href={props.url}
            target="_blank"
            className="parts__refdocuments__type"
            aria-label={`${viewDataSheetLabel} ${localization.opensNewWindow}`}
          >
            <img
              src={externalRedirect}
              className="parts__refdocuments__redirect"
              alt={viewDataSheetLabel}
              width={16}
              height={16}
            />
          </a>
        </span>
      </div>
    </div>
  );
};
export default Datasheets;
